// extracted by mini-css-extract-plugin
module.exports = {"deferredIcon":"deferredIcon_deferredIcon__Ty0ir"};